import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SpaceRightMixin = css`
  margin-right: 15px;
`;

export const RecordBtnMixin = css`
  &:disabled::after {
    background-color: rgba(255, 255, 255, 0.7);
  }
`;
